const metaTags = {
    Landing: {
        title: "LayerFF | Cybersecurity Tools & Expert Services",
        description:
          "LayerFF is a cybersecurity platform offering tools for network diagnostics, phishing analysis, secure data deletion, mobile forensics, vulnerability scanning, cryptography, and more. Contact our expert team for professional security and DevSecOps services.",
        og: {
          title: "LayerFF | Advanced Cybersecurity Tools & Expert Support",
          description:
            "Explore LayerFF’s platform for hands-on tools like phishing analysis, secure deletion, subnet calculators, and more. Our team also offers DevSecOps, threat intelligence, and digital forensics services.",
          url: "https://layerff.tech/landing",
        },
      },
      Contact: {
        title: "Contact LayerFF | Get in Touch with Cybersecurity Experts",
        description:
            "Reach out to the LayerFF team for tailored cybersecurity solutions, including digital forensics, DevSecOps, and threat intelligence consulting.",
        og: {
          title: "Contact LayerFF | Talk to Our Experts",
          description:
            "Have a question or need custom security support? Contact the LayerFF team directly through info@layerff.tech or call us at +256 774708048 or +256 772886750.",
          url: "https://layerff.tech/",
        },
    },     
   
    TraceMaster: {
        title: "TraceMaster | Phone & Email Intelligence Tool | LayerFF",
        description:
          "TraceMaster helps gather passive intelligence about phone numbers and email addresses including ISP details, location, registrant info, and metadata analysis.",
        og: {
          title: "TraceMaster | Digital Forensics for Phones & Emails",
          description:
            "Uncover metadata and ISP information from phone numbers and email addresses using TraceMaster on LayerFF.",
          url: "https://layerff.tech/TraceMaster",
        },
      },
      SubnetIQ: {
        title: "SubnetIQ | Advanced IPv4/IPv6 Subnet Calculator | LayerFF",
        description:
          "Calculate IPv4/IPv6 subnets with graphical topology, subnet validation, IP range analysis, and visual representation using SubnetIQ.",
        og: {
          title: "SubnetIQ | Graphical IP Subnet Calculator Tool",
          description:
            "Use SubnetIQ to validate and visualize subnets, generate IP topologies, and analyze address ranges efficiently.",
          url: "https://layerff.tech/SubnetIQ",
        },
      },
      MetaFlyse: {
              title: "MetaFlyse | Metadata Management & Forensics Tool | LayerFF",
              description:
                "MetaFlyse allows extraction, editing, and deletion of metadata within files, supporting forensic investigations and data privacy.",
              og: {
                title: "MetaFlyse | Metadata Extraction & Forensics Tool",
                description:
                  "Discover hidden metadata, edit file information, and perform forensic analysis with MetaFlyse on LayerFF.",
                url: "https://layerff.tech/metaflyse",
              },
            },
            TriSecGraphAuth: {
              title: "TriSec GraphAuth | Layered Image Graph Authentication | LayerFF",
              description:
                "TriSec GraphAuth provides a three-layer image verification system for layered security and user authentication resistant to spoofing.",
              og: {
                title: "TriSec GraphAuth | Multi-layer Image Authentication System",
                description:
                  "Secure user verification with a three-level image graph system, enhancing layered security and preventing spoofing.",
                url: "https://layerff.tech/3lelvelAuth",
              },
            },
      HashVault: {
        title: "HashVault | Advanced Hash Analysis & Monitoring Tool | LayerFF",
        description:
          "Generate, analyze, and visualize advanced hash algorithms with security insights, strength comparison, pattern recognition, and integrity monitoring using HashVault.",
        og: {
          title: "HashVault | Secure Hash Generator with Visual Intelligence",
          description:
            "Explore spectrum, waveform, and block patterns of hash outputs. HashVault delivers deep insights into hash integrity and strength.",
          url: "https://layerff.tech/hashing",
        },
      },
      CryptoTool: {
        title: "CryptoTool | Secure Encryption & Decryption Platform | LayerFF",
        description:
          "Encrypt and decrypt text, images, and files using symmetric and asymmetric algorithms like Blowfish, XOR, and Camellia. Check digital signatures, manage keys, and ensure data integrity.",
        og: {
          title: "CryptoTool | LayerFF Encryption Platform with Key Management",
          description:
            "Explore encryption with detailed logs, signature validation, and advanced cryptographic algorithms on CryptoTool.",
          url: "https://layerff.tech/crypto",
        },
      },
      IntegrityCheck: {
        title: "Integrity Check | Compare Files & Text with Precision | LayerFF",
        description:
          "Detect even microscopic differences in files and text. Supports checksum comparisons, base64 encoding/decoding, and detailed data modification analysis.",
        og: {
          title: "Integrity Check | Deep Comparison and Validation Tool",
          description:
            "Use Integrity Check to detect modifications, verify integrity of folders and files, and decode base64 accurately.",
          url: "https://layerff.tech/hashing",
        },
      },
      PhishGuard: {
        title: "PhishGuard | URL & Spam Message Phishing Analyzer | LayerFF",
        description:
          "Analyze suspicious URLs and messages with visual feedback on redirects, SSL, IPs, registrant data, DNSSEC, and technology stack for threat detection.",
        og: {
          title: "PhishGuard | Visual Phishing & Spam Analyzer",
          description:
            "PhishGuard gives detailed insights into phishing attempts including DNS records, tech stacks, and certificate info.",
          url: "https://layerff.tech/Phishing",
        },
      },
      Treateay: {
        title: "Treateay | IP & Domain Vulnerability Scanner | LayerFF",
        description:
          "Scan domains and IP addresses for open ports, service weaknesses, and vulnerabilities using Treateay.",
        og: {
          title: "Treateay | Network Vulnerability Assessment Tool",
          description:
            "Treateay identifies exposed ports and possible attack vectors in domains and IP addresses.",
          url: "https://layerff.tech/VScanner",
        },
      },
      CognitoNet: {
        title: "CognitoNet | Network Diagnostic & Visual Toolkit | LayerFF",
        description:
          "Diagnose networks with visualized tools like ping, traceroute, nslookup, and port scans. Easy for technical and non-technical users alike.",
        og: {
          title: "CognitoNet | Visual Network Troubleshooting Tool",
          description:
            "Run visual network tests for troubleshooting and diagnostics using CognitoNet on LayerFF.",
          url: "https://layerff.tech/CognitoNet",
        },
      },
      SecDEL: {
        title: "SecDEL | Secure File & Disk Deletion Tool | LayerFF",
        description:
          "Permanently erase files, folders, and disks using industry-standard secure deletion protocols to prevent recovery.",
        og: {
          title: "SecDEL | Advanced Secure Deletion Tool for Data",
          description:
            "Safely destroy sensitive data with certified wiping algorithms using SecDEL by LayerFF.",
          url: "https://layerff.tech/SecDEL",
        },
      },
      Team_Sudo_Root: {
        title: "F/N Nuru The Geek | Chief Security Architect - LayerFF",
        description:
          "F/N Nuru, CSA at LayerFF, leads cybersecurity innovation in DevOps, DevSecOps, Blockchain, AI, and Zero Trust Architecture. Contact: fhilarious@layerff.tech",
        og: {
          title: "F/N Nuru - DevSecOps & Cybersecurity Expert",
          description:
            "Meet F/N Nuru, LayerFF's CSA, pioneering DevSecOps, AI security, and advanced infrastructure hardening.",
          url: "https://layerff.tech/fn-nuru-the-geek",
        },
      },
    
      Team_Kikawa_Stanley: {
        title: "Kikawa Stanley | Systems Security Admin - LayerFF",
        description:
          "Kikawa Stanley is a specialist in Authentication, Authorization & Access Management (SSO/MFA/AAA) at LayerFF. ",
        og: {
          title: "Kikawa Stanley - Access Management Expert",
          description:
            "Secure your infrastructure with Kikawa Stanley's expertise in authentication and multi-factor access control.",
          url: "https://layerff.tech/team/Kikawa Stanley",
        },
      },
    
      Team_Jeff_Bwire: {
        title: "Jeff Bwire | Legal & Data Compliance Officer - LayerFF",
        description:
          "Jeff Bwire ensures regulatory compliance and secure data deletion strategies at LayerFF. ",
        og: {
          title: "Jeff Bwire - Data Compliance & Legal Advisor",
          description:
            "Jeff brings precision and legal rigor to data handling and secure deletion practices at LayerFF.",
          url: "https://layerff.tech/team/Jeff Bwire",
        },
      },
    
      Team_Muwanga_Ibra: {
        title: "Muwanga Ibra | Systems Security & Admin - LayerFF",
        description:
          "Muwanga Ibra is an expert in cryptographic integrity, system hardening, and advanced hashing at LayerFF. ",
        og: {
          title: "Muwanga Ibra - Cryptographic Security Specialist",
          description:
            "Muwanga secures LayerFF infrastructure with cutting-edge hashing and hardening techniques.",
          url: "https://layerff.tech/team/Muwanga Ibra",
        },
      },
    
      Team_Kizziri_Lule: {
        title: "Kizziri Lule | Backup & Recovery Strategist - LayerFF",
        description:
          "Kizziri Lule focuses on disaster recovery planning and ransomware mitigation strategies at LayerFF. ",
        og: {
          title: "Kizziri Lule - Recovery & Ransomware Strategist",
          description:
            "Defend your data with Kizziri's expertise in backups, failover, and recovery protocols.",
          url: "https://layerff.tech/team/Kizziri Lule",
        },
      },
    
      Team_Magala_Graham: {
        title: "Magala Graham | Security Product Manager - LayerFF",
        description:
          "Magala Graham leads security product integration and marketing strategy at LayerFF. ",
        og: {
          title: "Magala Graham - Security Product Strategy Lead",
          description:
            "Magala helps bring security tools to market with precision, usability, and technical insight.",
          url: "https://layerff.tech/team/Magala Graham",
        },
      },
    
      Team_Akera_Joyce: {
        title: "Akera Joyce | Crypto Engineer & Tech Support - LayerFF",
        description:
          "Akera Joyce is an expert in ECC, post-quantum cryptography, and LayerFF technical support.",
        og: {
          title: "Akera Joyce - Post-Quantum Crypto Engineer",
          description:
            "Joyce supports cutting-edge crypto tech and offers expert guidance at LayerFF HelpCenter.",
          url: "https://layerff.tech/team/Akera Joyce",
        },
      },
    
      Team_Ladu_Harry: {
        title: "Ladu Harry | Legal & Security Risk Analyst - LayerFF",
        description:
          "Ladu Harry specializes in phishing risk, legal compliance, and social engineering analysis.",
        og: {
          title: "Ladu Harry - Social Engineering & Compliance Analyst",
          description:
            "Ladu defends organizations against phishing and ensures legal-grade risk assessments.",
          url: "https://layerff.tech/team/Ladu Harry",
        },
      },
    
      Team_Olobo_Patrick: {
        title: "Olobo Patrick | Network Analysis & HelpCenter - LayerFF",
        description:
          "Olobo Patrick provides threat analysis, network recognition, and advanced help support.",
        og: {
          title: "Olobo Patrick - Threat Analyst & Help Support",
          description:
            "Olobo delivers deep network pattern recognition and frontline security support at LayerFF.",
          url: "https://layerff.tech/team/Olobo Patrick",
        },
      },
    
      Team_Fateh_Dhillon: {
        title: "Fateh Dhillon | Digital Detective & Security Marketing - LayerFF",
        description:
          "Fateh Dhillon specializes in mobile/email forensics, threat hunting, and cyber marketing. ",
        og: {
          title: "Fateh Dhillon - Mobile Forensics & Security Marketing",
          description:
            "Fateh uncovers threats through deep forensic work and promotes trusted LayerFF tools.",
          url: "https://layerff.tech/team/Fateh Dhillon",
        },
      },
    
      Team_Ana_Dorin: {
        title: "Ana Dorin | Financial & Tech Integration - LayerFF",
        description:
          "Ana Dorin integrates facial recognition into financial systems and manages educational tech. ",
        og: {
          title: "Ana Dorin - FinTech & Recognition Tech Lead",
          description:
            "Ana merges biometrics with finance and learning platforms for secure innovation.",
          url: "https://layerff.tech/team/Ana Dorin",
        },
      },
    
      Team_Nassimbwa_Hawah: {
        title: "Nassimbwa Hawah | Security Risk & Financial Analyst - LayerFF",
        description:
          "Nassimbwa Hawah assesses vulnerabilities, manages risk, and supports audits. ",
        og: {
          title: "Nassimbwa Hawah - Vulnerability & Compliance Specialist",
          description:
            "Nassimbwa drives risk-based decision-making and secure compliance practices at LayerFF.",
          url: "https://layerff.tech/team/Nassimbwa Hawah",
        },
      },
    
      Team_Phillipa_Babirye: {
        title: "Phillipa Babirye | Network Analyst - LayerFF",
        description:
          "Phillipa Babirye excels in performance optimization, traffic analysis, and protocol implementation. ",
        og: {
          title: "Phillipa Babirye - Network Performance & Protocol Expert",
          description:
            "Phillipa refines security posture through network visibility, tuning, and standards enforcement.",
          url: "https://layerff.tech/Phillipa Babirye",
        },
      },
    // Add more here...
  };
  
  export default metaTags;
  
  
